<template>
  <div class="senha-politicas">
    <div
      v-for="(regra, idx) in value.filter(m => m.visivel)" :key="idx" class="regra"
      :class="{ valida: regra.valida }"
    >
      <i v-if="regra.valida" class="icon-ic_check_green" />
      <i v-else class="icon-ic_close" />
      {{ regra.mensagem }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SenhaPoliticas',

  data() {
    return {

    }
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.regra {
  color: red;
}
.regra i {
  font-size: 14px;
}
.valida {
  color: green;
}
</style>
